export default __webpack_public_path__ + "66ae78838ffb1c6b334b0cceba37f32d.png";